export const isLoadingMore = (state) => state.articles.loadingMore;
export const hasMorePages = (state) => state.articles.page <= state.articles.total_pages;
export const getArticles = (state) => state.articles.articles



// WEBPACK FOOTER //
// ./src/selectors/articles.js